import _slicedToArray from "/builds/mfresearchtool/mfresearchtool-ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _get from "/builds/mfresearchtool/mfresearchtool-ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/get";
import _classCallCheck from "/builds/mfresearchtool/mfresearchtool-ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/builds/mfresearchtool/mfresearchtool-ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/builds/mfresearchtool/mfresearchtool-ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/builds/mfresearchtool/mfresearchtool-ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/builds/mfresearchtool/mfresearchtool-ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _assertThisInitialized from "/builds/mfresearchtool/mfresearchtool-ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _wrapNativeSuper from "/builds/mfresearchtool/mfresearchtool-ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/wrapNativeSuper";
import _defineProperty from "/builds/mfresearchtool/mfresearchtool-ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
var _cloudApi, _cloudWeb, _cloudApi2;
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == typeof h && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw new Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(typeof e + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw new Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, catch: function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
import { escapeRegExp, forEach, map, first, set, defaultsDeep, isUndefined, includes, isObject, remove, merge, isNil, isEmpty, assign, keys } from 'lodash';
import { initFetch } from '@trp-ta-nitro/http-js';

/**
 * Constants are in a separate file because otherwise there is a circular dependency of:
 *   env -> domains -> env
 */
var DEV = 'dev';
var SIT = 'sit';
var STAGE = 'stage';
var PROD = 'prod';
var ENVIRONMENTS = [DEV, SIT, STAGE, PROD];

/**
 * Configuration and manipulation of domains.
 */
/**
 * Returns a regular expression that will match all of the subdomains of the
 * passed domain. Since a domain can be any subset of a host, knowing the
 * domain is necessary.
 *
 * For example, if the domain is bloop.com, this will return a regex that will
 * match bloop.com, x.bloop.com, x.y.bloop.com, etc.
 *
 * @param domain
 */
function regexSubdomainsOf(domain) {
  var escaped = escapeRegExp(domain);
  return new RegExp("^([^.]+\\.)*".concat(escaped, "$"));
}
/**
 * Returns the subdomains of `domain` from the fully qualified domain name
 * `fqdn`.
 *
 * For example, if the domain is bloop.com and the fqdn is x.bloop.com, this
 * will return "x". If the domain is x.y.bloop.com, this will return "x.y".
 *
 * @param fqdn
 * @param domain
 */
function subdomainFromFqdn(fqdn, domain) {
  var escapedDomain = escapeRegExp(domain);
  var domainRegex = new RegExp("\\.?".concat(escapedDomain, "$"));
  return fqdn.replace(domainRegex, '');
}
/**
 * Returns a domain split into its component names in an array.
 *
 * @param domain
 */
function domainToParts(domain) {
  return domain.split('.');
}
/**
 * Normal value access by key in an object, but will default to the dev
 * environment's value if the object doesn't have a value for the passed
 * environment.
 *
 * @param subdomains
 * @param environment
 */
function envValue(subdomains, environment) {
  var subdomain = subdomains[environment];
  if (!subdomain) {
    subdomain = subdomains[DEV];
  }
  return subdomain;
}
// External Domains
// ================
var EXTERNAL_DOMAIN = 'troweprice.com';
var externalSubdomains = {
  cloudApi: (_cloudApi = {}, _defineProperty(_cloudApi, DEV, 'api.dev'), _defineProperty(_cloudApi, SIT, 'api.sit'), _defineProperty(_cloudApi, STAGE, 'api.confidence'), _defineProperty(_cloudApi, PROD, 'api.public'), _cloudApi),
  cloudWeb: (_cloudWeb = {}, _defineProperty(_cloudWeb, DEV, 'wwwdev'), _defineProperty(_cloudWeb, SIT, 'wwwsit'), _defineProperty(_cloudWeb, STAGE, 'wwwstage'), _defineProperty(_cloudWeb, PROD, 'www'), _cloudWeb)
};
/**
 * Functions to return various domains related to external auth. The domains differ based on
 * execution environment.
 */
var External = {
  cloudApiDomain: function cloudApiDomain(env) {
    var baseDomain = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : EXTERNAL_DOMAIN;
    return "".concat(envValue(externalSubdomains.cloudApi, env), ".").concat(baseDomain);
  },
  cloudWebDomain: function cloudWebDomain(env) {
    var baseDomain = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : EXTERNAL_DOMAIN;
    return "".concat(envValue(externalSubdomains.cloudWeb, env), ".").concat(baseDomain);
  }
};
// Internal Domains
// ================
var INTERNAL_DOMAIN = 'awstrp.net';
var internalSubdomains = {
  cloudApi: (_cloudApi2 = {}, _defineProperty(_cloudApi2, DEV, 'api.dev'), _defineProperty(_cloudApi2, SIT, 'api.sit'), _defineProperty(_cloudApi2, STAGE, 'api.stage'), _defineProperty(_cloudApi2, PROD, 'api.prod'), _cloudApi2)
};
/**
 * Functions to return various domains related to internal auth. The domains differ based on
 * execution environment.
 */
var Internal = {
  cloudApiDomain: function cloudApiDomain(env) {
    var baseDomain = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : INTERNAL_DOMAIN;
    return "".concat(envValue(internalSubdomains.cloudApi, env), ".").concat(baseDomain);
  }
};
// Localhost
// =========
var LOCALHOST = 'localhost';
var LOCALHOST_DEV_DOMAINS = [LOCALHOST, "".concat(LOCALHOST, ".").concat(EXTERNAL_DOMAIN), "".concat(LOCALHOST, ".").concat(INTERNAL_DOMAIN)];
/**
 * Returns true if the passed hostname is a loopback address or one of the dev domains.
 *
 * @param hostname
 */
function isLocalhost$1(hostname) {
  return hostname === '127.0.0.0' || LOCALHOST_DEV_DOMAINS.includes(hostname);
}
function parseApigeeResponse(responseBody) {
  var _a;
  try {
    var json = JSON.parse(responseBody);
    if ((_a = json.fault) === null || _a === void 0 ? void 0 : _a.faultstring) {
      return json.fault;
    }
  } catch (err) {
    // ignored
  }
  // this was likely not a proper apigee error response
  return undefined;
}
function apigeeFaultErrorMessage(fault) {
  var _a;
  var message = fault.faultstring;
  var errorCode = (_a = fault.detail) === null || _a === void 0 ? void 0 : _a.errorcode;
  if (errorCode) {
    message += "; ".concat(errorCode);
  }
  return message;
}
var ApigeeError = /*#__PURE__*/function (_Error) {
  _inherits(ApigeeError, _Error);
  function ApigeeError(fault) {
    var _this;
    _classCallCheck(this, ApigeeError);
    _this = _possibleConstructorReturn(this, _getPrototypeOf(ApigeeError).call(this, apigeeFaultErrorMessage(fault))); // 'Error' breaks prototype chain here
    _this.fault = fault;
    Object.setPrototypeOf(_assertThisInitialized(_assertThisInitialized(_this)), (this instanceof ApigeeError ? this.constructor : void 0).prototype); // restore prototype chain
    // If the name is anything but an empty string, it is prepended to the error message. This
    // can be obnoxious when embedding messages into other strings via toString. This prevents
    // that from occurring. If a consumer wants a prefix, they can add it themselves or just
    // set name again.
    // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Error/toString#Description
    _this.name = 'ApigeeError';
    return _this;
  }
  _createClass(ApigeeError, null, [{
    key: "fromResponseBody",
    value: function fromResponseBody(responseBody) {
      var fault = parseApigeeResponse(responseBody);
      if (!fault) {
        return undefined;
      }
      return new ApigeeError(fault);
    }
  }, {
    key: "throwIfFault",
    value: function throwIfFault(responseBody) {
      var err = ApigeeError.fromResponseBody(responseBody);
      if (err) {
        throw err;
      }
    }
  }]);
  return ApigeeError;
}(_wrapNativeSuper(Error));
var AuthError = /*#__PURE__*/function (_Error2) {
  _inherits(AuthError, _Error2);
  function AuthError(name, message, cause) {
    var _this2;
    _classCallCheck(this, AuthError);
    _this2 = _possibleConstructorReturn(this, _getPrototypeOf(AuthError).call(this, message)); // 'Error' breaks prototype chain here
    Object.setPrototypeOf(_assertThisInitialized(_assertThisInitialized(_this2)), (this instanceof AuthError ? this.constructor : void 0).prototype); // restore prototype chain
    _this2.cause = cause;
    // If the name is anything but an empty string, it is prepended to the error message. This
    // can be obnoxious when embedding messages into other strings via toString. This prevents
    // that from occurring. If a consumer wants a prefix, they can add it themselves or just
    // set name again.
    // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Error/toString#Description
    _this2.name = name;
    return _this2;
  }
  _createClass(AuthError, [{
    key: "toString",
    value: function toString() {
      var s = _get(_getPrototypeOf(AuthError.prototype), "toString", this).call(this);
      if (this.cause) {
        s = "".concat(s, "\nCaused by: ").concat(this.cause.toString());
      }
      return s;
    }
  }]);
  return AuthError;
}(_wrapNativeSuper(Error));
var NetworkError = /*#__PURE__*/function (_AuthError) {
  _inherits(NetworkError, _AuthError);
  function NetworkError(message) {
    _classCallCheck(this, NetworkError);
    return _possibleConstructorReturn(this, _getPrototypeOf(NetworkError).call(this, 'Network Error', message));
  }
  return NetworkError;
}(AuthError);
var RefreshError = /*#__PURE__*/function (_AuthError2) {
  _inherits(RefreshError, _AuthError2);
  function RefreshError(responseBody) {
    var _this3;
    _classCallCheck(this, RefreshError);
    var message = 'Token refresh failed.';
    var fault = parseApigeeResponse(responseBody);
    if (fault) {
      message += ' ' + fault.faultstring;
    }
    _this3 = _possibleConstructorReturn(this, _getPrototypeOf(RefreshError).call(this, 'Refresh Error', message));
    _this3.responseBody = responseBody;
    return _this3;
  }
  return RefreshError;
}(AuthError);
var UnsupportedAuthTypeError = /*#__PURE__*/function (_AuthError3) {
  _inherits(UnsupportedAuthTypeError, _AuthError3);
  function UnsupportedAuthTypeError(authType) {
    _classCallCheck(this, UnsupportedAuthTypeError);
    return _possibleConstructorReturn(this, _getPrototypeOf(UnsupportedAuthTypeError).call(this, 'Unconfigured AuthType', "Auth type was determined to be '".concat(authType, "', which is unconfigured.")));
  }
  return UnsupportedAuthTypeError;
}(AuthError);
var UnknownAuthTypeError = /*#__PURE__*/function (_AuthError4) {
  _inherits(UnknownAuthTypeError, _AuthError4);
  function UnknownAuthTypeError(authType, validTypes) {
    _classCallCheck(this, UnknownAuthTypeError);
    return _possibleConstructorReturn(this, _getPrototypeOf(UnknownAuthTypeError).call(this, 'Unknown AuthType', "'".concat(authType, "' must be one of: ").concat(validTypes.join(', '))));
  }
  return UnknownAuthTypeError;
}(AuthError);
var DEFAULT_URL_PREFIX = 'https://localhost';
function isUrlString(configUrl) {
  return typeof configUrl === 'string';
}
function coerceToUrlParts(configUrl) {
  if (isUrlString(configUrl)) {
    return stringToUrlParts(configUrl);
  }
  return configUrl;
}
function coerceToConfigUrl(orig, urlParts) {
  if (isUrlString(orig)) {
    return urlPartsToString(urlParts);
  }
  return urlParts;
}
function leftTrim(s, char) {
  if (s.startsWith(char)) {
    s = s.substr(char.length);
  }
  return s;
}
function paramsFromQuery(query) {
  if (!query) {
    return {};
  }
  if (query.startsWith('?')) {
    query = query.substr(1);
  }
  var params = {};
  query.split('&').forEach(function (param) {
    var _param$split = param.split('=', 2),
      _param$split2 = _slicedToArray(_param$split, 2),
      name = _param$split2[0],
      value = _param$split2[1];
    params[name] = value;
  });
  return params;
}
function addUrlPart(url, separator, part) {
  if (!part) {
    return url;
  }
  part = leftTrim(part, separator);
  return "".concat(url).concat(separator).concat(part);
}
function queryFromParams(params) {
  return map(params, function (value, name) {
    return "".concat(name, "=").concat(value);
  }).join('&');
}
function urlPartRequired(part) {
  if (!part) {
    throw new Error('Cannot buildUrl(). Must have at least a scheme and hostname, and no location was available.');
  }
  return part;
}
function stringToUrlParts(urlStr) {
  var relativeUrl = false;
  if (urlStr[0] === '/') {
    relativeUrl = true;
    // the URL constructor wants a full url, so if this looks like a relative url,
    // make it look like a full url
    urlStr = DEFAULT_URL_PREFIX + urlStr;
  }
  var url = new URL(urlStr);
  var urlParts = {
    host: url.hostname,
    // trim off the ending :
    scheme: url.protocol.substr(0, url.protocol.length - 1)
  };
  if (url.hash) {
    // trim off the starting #
    urlParts.fragment = url.hash.substr(1);
  }
  if (url.pathname && url.pathname !== '/') {
    urlParts.path = url.pathname;
  }
  if (url.port) {
    urlParts.port = parseInt(url.port);
  }
  var query = url.searchParams.toString();
  if (query) {
    urlParts.query = query;
  }
  if (relativeUrl) {
    delete urlParts.host;
    delete urlParts.scheme;
  }
  return urlParts;
}
/**
 * Turn the passed `urlParts` into an actual url.
 *
 * @param urlParts
 */
function urlPartsToString(urlParts) {
  var _a;
  var url = '';
  if (urlParts.scheme || urlParts.host || urlParts.port) {
    url += "".concat(urlPartRequired(urlParts.scheme), "://").concat(urlPartRequired(urlParts.host));
    url = addUrlPart(url, ':', (_a = urlParts.port) === null || _a === void 0 ? void 0 : _a.toString());
  }
  url = addUrlPart(url, '/', urlParts.path);
  url = addUrlPart(url, '?', urlParts.query);
  url = addUrlPart(url, '#', urlParts.fragment);
  return url;
}
function withQueryParams(configUrl, queryParams) {
  var urlParts = coerceToUrlParts(configUrl);
  var params = paramsFromQuery(urlParts.query);
  forEach(queryParams, function (value, name) {
    if (value === undefined) {
      return;
    }
    params[name] = encodeURIComponent(value);
  });
  urlParts.query = queryFromParams(params);
  return coerceToConfigUrl(configUrl, urlParts);
}
/**
 * Returns the passed url, without its search part (everything after ?).
 *
 * @param configUrl
 */
function withoutQuery(configUrl) {
  var urlParts = coerceToUrlParts(configUrl);
  delete urlParts.query;
  return coerceToConfigUrl(configUrl, urlParts);
}

/**
 * A layer over interacting with window.location that allows overriding the
 * global location temporarily for testing.
 */
function locationScheme(location) {
  var protocol = location === null || location === void 0 ? void 0 : location.protocol;
  if (!protocol) {
    return undefined;
  }
  if (protocol.endsWith(':')) {
    // the URL protocol includes a colon, which shouldn't be returned
    protocol = protocol.substr(0, protocol.length - 1);
  }
  return protocol;
}
function checkedLocation(location) {
  if (!location) {
    throw new Error('Missing location.');
  }
  return location;
}
function defaultUrlPartsFromLocation(location, urlParts) {
  // only includes the parts of the url that are likely to actually be useful in the
  // target url
  if (!urlParts.scheme) {
    urlParts.scheme = locationScheme(location);
  }
  if (!urlParts.host) {
    urlParts.host = location.hostname;
  }
  return urlParts;
}
/**
 * Create a url (a string) from the passed `configUrl`.
 *
 * If the configUrl is a string, it is returned verbatim.
 *
 * If the configUrl is an object of url parts, the parts will be assembled into
 * a url. If one of the required parts is missing and cannot be defaulted, an
 * error will be thrown.
 *
 * @param location
 * @param configUrl
 */
function buildOptionalUrl(location, configUrl) {
  if (!configUrl) {
    return undefined;
  }
  if (typeof configUrl === 'string') {
    return configUrl;
  }
  configUrl = defaultUrlPartsFromLocation(location, configUrl);
  return urlPartsToString(configUrl);
}
function buildUrl(location, configUrl) {
  var url = buildOptionalUrl(location, configUrl);
  if (!url) {
    throw new Error('Could not build required url.');
  }
  return url;
}
/**
 * Returns true if the current location is localhost, false otherwise.
 *
 * @param location The location to check.
 */
function isLocalhost(location) {
  return isLocalhost$1(location.hostname);
}
/**
 * Returns the value of a query param in the current location.
 *
 * @param location The Location to check.
 * @param name The name of the query param to return.
 */
function queryParamValue(location, name) {
  var _a;
  if (!location.href) {
    return undefined;
  }
  var searchParams = new URL(location.href).searchParams;
  return (_a = searchParams.get(name)) !== null && _a !== void 0 ? _a : undefined;
}
function windowLocation() {
  // typescript will complain window is undefined unless explicitly checked first
  if (typeof window === 'undefined') {
    return undefined;
  }
  return window.location;
}
var TYPE_EXTERNAL = 'external';
var TYPE_INTERNAL = 'internal';
var TYPES = [TYPE_EXTERNAL, TYPE_INTERNAL];
// use this query parameter to force the library into a specific auth type when
// the host is localhost
var LOCALHOST_AUTH_TYPE_PARAM = 'localhostAuthType';
var LOCALHOST_AUTH_TYPE_STORAGE_KEY = 'nitro.auth.type';
/**
 * Returns the current url with the domain in `fromAuthTypeMapping` replaced
 * with the domain in `toAuthTypeMapping`.
 *
 * @param location
 * @param fromAuthTypeMapping
 * @param toAuthTypeMapping
 */
function redirectUrl(location, fromAuthTypeMapping, toAuthTypeMapping) {
  var url = new URL(location.href);
  var subdomain = subdomainFromFqdn(url.hostname, fromAuthTypeMapping.domain);
  url.hostname = "".concat(subdomain, ".").concat(toAuthTypeMapping.domain);
  return url.toString();
}
/**
 * Return the first type TypeMapping that is for a type that is in `types`.
 *
 * Will throw an error if a type mapping cannot be found.
 *
 * @param typeMappings
 * @param types
 */
function findTypeMapping(typeMappings, types) {
  var authTypeMapping = typeMappings.find(function (m) {
    return types.includes(m.type);
  });
  if (!authTypeMapping) {
    var typesStr = types.join(', ');
    throw new Error("Could not find type mapping for ".concat(typesStr, ". Check type mappings and configured types."));
  }
  return authTypeMapping;
}
/**
 * Returns the auth type for localhost. If it's set in a query param, will
 * return that value. Will cache the auth type in local storage and return
 * it from there if the query param is unavailable.
 *
 * If the auth type is not available from a query param or local storage,
 * returns undefined.
 */
function localhostAuthType(location, storage) {
  var _a;
  var paramValue = queryParamValue(location, LOCALHOST_AUTH_TYPE_PARAM);
  var storageValue = (_a = storage === null || storage === void 0 ? void 0 : storage.getItem(LOCALHOST_AUTH_TYPE_STORAGE_KEY)) !== null && _a !== void 0 ? _a : undefined;
  var value = paramValue;
  if (value) {
    console.log("Using ".concat(value, " as auth type, from query param."));
  } else {
    // use the cached local auth type (which may be null) if the param one isn't there
    value = storageValue;
    if (value) {
      console.log("Using ".concat(value, " as auth type, from local storage."));
    }
  }
  if (paramValue && paramValue !== storageValue) {
    if (storage) {
      // if there was a param auth type, cache it in local storage
      storage.setItem(LOCALHOST_AUTH_TYPE_STORAGE_KEY, paramValue);
      console.log("Updating local storage with ".concat(value, " as localhost auth type."));
    } else {
      console.warn('Cannot storage localhost auth type. No storage.');
    }
  }
  // verify the value is a proper type
  return TYPES.find(function (t) {
    return t === value;
  });
}
/**
 * Figure out what type of auth to use (internal or external).
 *
 * @param location
 * @param storage
 * @param typeMappings The mappings from host to type.
 * @param availableTypes Which types are available for the current usage.
 */
function determineAuthType(location, storage, typeMappings, availableTypes) {
  var _iterator = _createForOfIteratorHelper(typeMappings),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var authTypeMapping = _step.value;
      if (authTypeMapping.hostRegex.test(location.hostname)) {
        return authTypeMapping;
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  if (isLocalhost(location)) {
    // localhost can't be mapped automatically to a type, because it's not a
    // proper domain, however it is useful during development to be able to use
    // any auth type...so the auth type can be forced via a query parameter,
    // but only for localhost
    var authType = localhostAuthType(location, storage);
    if (authType) {
      return findTypeMapping(typeMappings, [authType]);
    }
    // if no query param directing which type of auth type to use, use
    // the first available
    return findTypeMapping(typeMappings, availableTypes);
  }
  throw new Error("Could not determine auth type from host '".concat(location.hostname, "'."));
}
/**
 * Provides support for managing a type of auth, for example external or
 * internal.
 *
 * This is its own separate functionality to insulate the auth services from
 * having to know everything about every auth service. Since this is responsible
 * for checking that the auth type is appropriate and redirecting to other
 * types, the auth service can be instantiated and used blindly without issue.
 */
var AuthType = /*#__PURE__*/function () {
  function AuthType(options) {
    _classCallCheck(this, AuthType);
    var _a;
    this.location = options.location;
    this.storage = options.storage;
    // determines what type of auth the user is supposed to be using based
    // on the current hostname
    var typeMapping = determineAuthType(this.location, this.storage, options.typeMappings, options.supportedTypes);
    if (!typeMapping) {
      throw new Error('Could not determine type mapping.');
    }
    this.redirectInterceptor = options.redirectInterceptor;
    this.redirectOnUnsupportedType = (_a = options.redirectOnUnsupportedType) !== null && _a !== void 0 ? _a : false;
    this.supportedTypes = options.supportedTypes;
    this.typeMapping = typeMapping;
    this.typeMappings = options.typeMappings;
    this.checkSupported();
  }
  /**
   * Will redirect the user to the proper url for the first supported type
   * available, if redirectOnUnsupportedType is true.
   *
   * If redirectOnUnsupportedType is false, this will error.
   */
  _createClass(AuthType, [{
    key: "handleUnsupportedType",
    value: function handleUnsupportedType() {
      if (this.redirectOnUnsupportedType) {
        var url = redirectUrl(this.location, this.typeMapping, findTypeMapping(this.typeMappings, this.supportedTypes));
        if (this.redirectInterceptor) {
          url = this.redirectInterceptor(this.typeMapping, url);
        }
        if (url) {
          this.location.assign(url);
        }
      }
      throw new UnsupportedAuthTypeError(this.typeMapping.type);
    }
    /**
     * Checks that what was determined to be the proper auth type is actually
     * one of the auth types that the user is allowed to use.
     */
  }, {
    key: "checkSupported",
    value: function checkSupported() {
      if (this.supportedTypes.includes(this.typeMapping.type)) {
        return;
      }
      this.handleUnsupportedType();
    }
    /**
     * Build a redirect url from the current location's url to one appropriate
     * for the passed `type`.
     *
     * @param type
     */
  }, {
    key: "redirectUrlToType",
    value: function redirectUrlToType(type) {
      var toTypeMapping = findTypeMapping(this.typeMappings, [type]);
      return redirectUrl(this.location, this.typeMapping, toTypeMapping);
    }
  }]);
  return AuthType;
}();
function externalSubdomainToEnv(subdomain) {
  var _a;
  var firstSubdomain = first(domainToParts(subdomain));
  if (!firstSubdomain) {
    return PROD;
  }
  return (_a = ENVIRONMENTS.find(function (e) {
    return firstSubdomain.endsWith(e);
  })) !== null && _a !== void 0 ? _a : PROD;
}
function internalSubdomainToEnv(subdomain) {
  var _a;
  return (_a = ENVIRONMENTS.find(function (e) {
    return subdomain.endsWith(e);
  })) !== null && _a !== void 0 ? _a : PROD;
}
/**
 * Return the environment (ex: dev, prod) based on the domain. Assumes that
 * the domain is well known and has the environment embedded in one of its
 * subdomains.
 *
 * For example, the wwwdev.troweprice.com environment is targeting dev. The
 * www.dev.awstrp.net environment is also targeting dev.
 *
 * A type mapping is needed as the environment is determined in a type-specific
 * manner, and the domain is what determines which subdomains to consider.
 *
 * @param fqdn The fully qualified domain name to pull the environment from.
 * @param typeMapping The current type mapping.
 */
var environmentFromDomain = function environmentFromDomain(fqdn, typeMapping) {
  if (isLocalhost$1(fqdn)) {
    return DEV;
  }
  var subdomain = subdomainFromFqdn(fqdn, typeMapping.domain);
  if (subdomain) {
    switch (typeMapping.type) {
      case TYPE_EXTERNAL:
        return externalSubdomainToEnv(subdomain);
      case TYPE_INTERNAL:
        return internalSubdomainToEnv(subdomain);
    }
  }
  return PROD;
};
/**
 * Return the environment (ex: dev, prod) based on the current location. Assumes
 * that the location is an external (troweprice.com) location.
 *
 * @param location
 */
function environmentFromExternalLocation(location) {
  return environmentFromDomain(location.hostname, {
    domain: EXTERNAL_DOMAIN,
    hostRegex: regexSubdomainsOf(EXTERNAL_DOMAIN),
    type: 'external'
  });
}

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise */

function __awaiter(thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
}
var CONTENT_TYPE = {
  JSON: 'application/json'
};
var DEFAULT_API_KEY_HEADER = 'apikey';
function applyDefaults(requestOptions) {
  return defaultsDeep(requestOptions, {
    credentials: 'include',
    headers: {
      Accept: CONTENT_TYPE.JSON,
      'X-TRP-Requested-With': 'nitro-auth-service'
    },
    mode: 'cors'
  });
}
/**
 * Adds default options and provides builder capabilities for request options.
 */
var Builder = /*#__PURE__*/function () {
  function Builder(options) {
    _classCallCheck(this, Builder);
    var _a, _b;
    this.apiKey = options.apiKey;
    this.apiKeyHeaderName = (_a = options.apiKeyHeaderName) !== null && _a !== void 0 ? _a : DEFAULT_API_KEY_HEADER;
    this.options = applyDefaults((_b = options.initialOptions) !== null && _b !== void 0 ? _b : {});
  }
  _createClass(Builder, [{
    key: "build",
    value: function build() {
      return this.options;
    }
  }, {
    key: "withApiKey",
    value: function withApiKey() {
      if (!this.apiKeyHeaderName) {
        throw new Error('RequestOptions.withApiKey() does not have apiKeyHeaderName configured.');
      }
      if (!this.apiKey) {
        throw new Error('RequestOptions.withApiKey() does not have apiKey configured.');
      }
      set(this.options, ['headers', this.apiKeyHeaderName], this.apiKey);
      return this;
    }
  }, {
    key: "withBody",
    value: function withBody(body) {
      this.options.body = body;
      return this;
    }
  }, {
    key: "withHeader",
    value: function withHeader(name, value) {
      set(this.options, ['headers', name], value);
      return this;
    }
  }, {
    key: "withContentType",
    value: function withContentType(contentType) {
      return this.withHeader('Content-Type', contentType);
    }
  }, {
    key: "withJsonBody",
    value: function withJsonBody(payload) {
      return this.withBody(JSON.stringify(payload)).withContentType(CONTENT_TYPE.JSON);
    }
  }, {
    key: "withMethod",
    value: function withMethod(method) {
      this.options.method = method;
      return this;
    }
  }]);
  return Builder;
}();
var RequestOptions = /*#__PURE__*/function () {
  function RequestOptions() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    _classCallCheck(this, RequestOptions);
    this.apiKey = options.apiKey;
    this.apiKeyHeaderName = options.apiKeyHeader;
  }
  _createClass(RequestOptions, [{
    key: "options",
    value: function options() {
      var _options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return new Builder({
        apiKey: this.apiKey,
        apiKeyHeaderName: this.apiKeyHeaderName,
        initialOptions: _options
      });
    }
  }]);
  return RequestOptions;
}();
function coerceRegisterUrl(env, registerUrl) {
  if (isUrlString(registerUrl)) {
    return registerUrl;
  }
  var defaultUrl = {
    host: External.cloudApiDomain(env),
    path: '/common-login-public/service/auth/logout/callbacks',
    scheme: 'https'
  };
  return Object.assign({}, defaultUrl, registerUrl);
}
/**
 * Represents the logout callback mechanism provided by common logout. The expected workflow is:
 *
 *   - Instantiate an instance of this class
 *   - Register a callback using register() (or one of the callback-specific methods)
 *   - When any other app uses the common logout page, the callback will be executed
 *
 * This only applies to external (troweprice.com) users.
 */
var CommonLogoutCallback = /*#__PURE__*/function () {
  function CommonLogoutCallback(options) {
    _classCallCheck(this, CommonLogoutCallback);
    var _a, _b, _c, _d;
    this.location = checkedLocation((_a = options.location) !== null && _a !== void 0 ? _a : windowLocation());
    this.environment = (_b = options.environment) !== null && _b !== void 0 ? _b : environmentFromExternalLocation(this.location);
    this.fetch = (_c = options.fetch) !== null && _c !== void 0 ? _c : initFetch().build();
    this.hooks = (_d = options.hooks) !== null && _d !== void 0 ? _d : {};
    this.registerUrl = coerceRegisterUrl(this.environment, options.registerUrl);
    this.requestOptions = new RequestOptions({
      apiKey: options.apiKey
    });
  }
  /**
   * A wrapper around fetch that uses the configured fetch option applies an optionally configured
   * request interceptor to augment the request.
   *
   * @param url
   * @param options
   */
  _createClass(CommonLogoutCallback, [{
    key: "fetchWithInterceptor",
    value: function fetchWithInterceptor(url, options) {
      var _a;
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if ((_a = this.hooks) === null || _a === void 0 ? void 0 : _a.requestInterceptor) {
                options = this.hooks.requestInterceptor(url, options);
              }
              return _context.abrupt("return", this.fetch(url, options));
            case 2:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
    }
    /**
     * Registers one or more common logout callbacks for execution when any app redirects to the
     * common logout page.
     *
     * This method forwards the passed payload on to the /register endpoint without validation,
     * so the caller can provide something invalid. The other convenience methods offer safer
     * uses. However, this means that future callback types can be used without updating this
     * library.
     *
     * If register fails a simple error will be thrown. Inspect the registration network hit in
     * the browser's console for more information.
     *
     * @param logoutCallbacks
     */
  }, {
    key: "register",
    value: function register() {
      for (var _len = arguments.length, logoutCallbacks = new Array(_len), _key = 0; _key < _len; _key++) {
        logoutCallbacks[_key] = arguments[_key];
      }
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var url, response;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              url = buildUrl(this.location, this.registerUrl);
              _context2.next = 3;
              return this.fetchWithInterceptor(url, this.requestOptions.options().withApiKey().withMethod('POST').withJsonBody(logoutCallbacks).build());
            case 3:
              response = _context2.sent;
              if (response.ok) {
                _context2.next = 6;
                break;
              }
              throw new Error("Could not register logout callback: ".concat(response.statusText, " (").concat(response.status, ")"));
            case 6:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
    }
    /**
     * Registers a 'fetch' callback. The callback will be executed by way of a browser fetch on
     * logout.
     *
     * @param app The identifier of the specific app the logout is for.
     * @param url The url to use with browser fetch. Will be called with a GET.
     * @param apiKey An optional apiKey to use with the fetch callback when executed. Will be passed
     *               in the apikey header.
     */
  }, {
    key: "registerFetch",
    value: function registerFetch(app, url, apiKey) {
      var callback = {
        app: app,
        type: 'fetch',
        url: url
      };
      if (apiKey) {
        callback.apiKey = apiKey;
      }
      return this.register(callback);
    }
  }]);
  return CommonLogoutCallback;
}();
/**
 * An implementation of Cookies that interacts with the browser's real cookies.
 */
var DocumentCookies = /*#__PURE__*/function () {
  function DocumentCookies(document) {
    _classCallCheck(this, DocumentCookies);
    if (document) {
      this.document = document;
    } else if (typeof window !== 'undefined') {
      this.document = window.document;
    } else {
      // if the Document is unavailable this is still instantiated, but the methods will likely not
      // work...this is intentional to facilitate not having this blow up during testing, and with
      // the understanding that browsers will always have the Document
      this.document = null;
    }
  }
  _createClass(DocumentCookies, [{
    key: "safeDocument",
    value: function safeDocument() {
      if (!this.document) {
        throw new Error('Missing window.document.');
      }
      return this.document;
    }
    /**
     * Essentially document.cookie="name=value", but wrapped in the Cookies
     * abstraction.
     *
     * @param name The name of the cookie to set.
     * @param value The string value to set the cookie to.
     * @param options Optional overrides for default behavior like setting a
     *                cookie's path.
     */
  }, {
    key: "setCookie",
    value: function setCookie(name, value) {
      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      var cookie = "".concat(name, "=").concat(value);
      if (options.path) {
        cookie += "; path=".concat(options.path);
      }
      this.safeDocument().cookie = cookie;
    }
  }]);
  return DocumentCookies;
}(); // typescript will complain window is undefined unless explicitly checked first
function localStorage() {
  if (typeof window === 'undefined') {
    return undefined;
  }
  return window.localStorage;
}

/**
 * Many options as they are passed are optional, but are assigned a default
 * before actually being used. This allows that to be enforced.
 *
 * @param t
 */
function defaultedOpt(t) {
  if (isUndefined(t)) {
    throw new Error('An option that was supposed to have a default is undefined.');
  }
  return t;
}
function jsonErrorMessage(body) {
  if (!body.error) {
    return undefined;
  }
  var message = body.error;
  if (body.details) {
    message += "; ".concat(body.details);
  }
  return message;
}
function checkResponseError(response) {
  var allowedStatuses = [400, 401, 403];
  if (!response.ok && !includes(allowedStatuses, response.status)) {
    throw new NetworkError("Unexpected status ".concat(response.status, " from ").concat(response.url, "."));
  }
}
/**
 *  There is not a consistent format for error messages, this tries to figure
 *  out a structured error message (based on known formats), but falls back to
 *  returning the body of the response.
 *
 * @param response
 * @param responseBody
 */
function coerceResponseErrorMessage(response, responseBody) {
  var message = responseBody;
  try {
    var json = JSON.parse(responseBody);
    if (isObject(json)) {
      message = jsonErrorMessage(json);
    }
  } catch (err) {
    // ignore (presumably it was not json)
  }
  return "".concat(response.url, " [").concat(response.status, "] - ").concat(message);
}
var NewAuthState = {
  Error: function Error(cause) {
    return {
      authenticated: false,
      cause: cause,
      unauthenticatedReason: 'see cause'
    };
  },
  Reason: function Reason(reason) {
    return {
      authenticated: false,
      unauthenticatedReason: reason
    };
  }
};
var DEFAULT_DELEGATE_USER_PARAM = 'delegateUser';
var DEFAULT_ECHO_URL = {
  path: '/architecture-reference-implementations_echo-oauth-token/echo',
  scheme: 'https'
};
/**
 *  Given a response that was not a 2xx, creates an AuthState based on the response
 *  body. There can be many causes for a non-2xx, this checks the known ones (ex: Apigee
 *  faults) and attempts to make them obvious.
 *
 * @param response
 * @param body
 */
function authResponseNotOk(response, body) {
  var apigeeError = ApigeeError.fromResponseBody(body);
  if (apigeeError) {
    return NewAuthState.Error(apigeeError);
  }
  return NewAuthState.Reason(coerceResponseErrorMessage(response, body));
}
function authResponseOk(responseBody) {
  var authResponse;
  try {
    authResponse = JSON.parse(responseBody);
  } catch (err) {
    throw new Error('could not parse auth response: ' + err.message);
  }
  var authState = {
    authenticated: true,
    entitlements: authResponse.entitlements,
    userId: authResponse.uid
  };
  if (authResponse.exp) {
    // the exp is only available from /me for internal sessions
    authState.expiresAt = authResponse.exp;
  }
  return authState;
}
function parseAuthResponse(response) {
  return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
    var body;
    return _regeneratorRuntime().wrap(function _callee3$(_context3) {
      while (1) switch (_context3.prev = _context3.next) {
        case 0:
          _context3.next = 2;
          return response.text();
        case 2:
          body = _context3.sent;
          if (!(response.status !== 200)) {
            _context3.next = 5;
            break;
          }
          return _context3.abrupt("return", authResponseNotOk(response, body));
        case 5:
          return _context3.abrupt("return", authResponseOk(body));
        case 6:
        case "end":
          return _context3.stop();
      }
    }, _callee3);
  }));
}
function defaultLoginBehavior(returnUrl) {
  // this promise intentionally does not resolve or reject, it is expected that the redirect
  // will occur and the entire app will be unloaded...note that if login becomes a process that's
  // not based on a redirect (ex: logging in on the current page), then this promise should be
  // changed to resolve once login is complete
  return function (authService, location) {
    return new Promise(function () {
      location.assign(authService.buildLoginUrl(returnUrl));
    });
  };
}
/**
 * A base class that contains common behavior used by all current auth services.
 */
var BaseAuthService = /*#__PURE__*/function () {
  function BaseAuthService(options) {
    _classCallCheck(this, BaseAuthService);
    var _a, _b;
    this.authStateListeners = [];
    this.authType = options.authType;
    this.authUrl = defaultedOpt(options.authUrl);
    this.baseHooks = defaultedOpt(options.hooks);
    this.cookies = options.cookies;
    this.customerWebViewEnabled = Boolean(options.customerWebViewEnabled);
    this.echoUrl = Object.assign({}, DEFAULT_ECHO_URL, options.echoUrl);
    this.environment = options.environment;
    this.fetch = (_a = options.fetch) !== null && _a !== void 0 ? _a : initFetch().build();
    this.location = options.location;
    this.requestOptions = new RequestOptions({
      apiKey: options.apiKey,
      apiKeyHeader: (_b = options.names) === null || _b === void 0 ? void 0 : _b.headerApiKey
    });
    this.requireAuthentication = Boolean(options.requireAuthentication);
  }
  /**
   * A wrapper around fetch that both applies common headers (including api key)
   * and uses an optionally configured request interceptor to augment the
   * request.
   *
   * @param url
   * @param options
   */
  _createClass(BaseAuthService, [{
    key: "fetchWithInterceptor",
    value: function fetchWithInterceptor(url, options) {
      var _a;
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              if ((_a = this.baseHooks) === null || _a === void 0 ? void 0 : _a.requestInterceptor) {
                options = this.baseHooks.requestInterceptor(url, options);
              }
              return _context4.abrupt("return", this.fetch(url, options));
            case 2:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this);
      }));
    }
    /**
     * Hits the passed `authUrl` to determine both that the user is authenticated
     * and what their entitlements are. Returns the authentication status, and
     * if authenticated, their user id and entitlements.
     *
     * If not authenticated and there was an error, will return the error as
     * well (essentially the reason they're not authenticated).
     *
     * This assumes that the thing that authenticates the user (ex: a token) will
     * automatically be applied by the fetch, either by a browser (a cookie)
     * or the configured request interceptor.
     *
     * @param authUrl
     */
  }, {
    key: "fetchAuthorization",
    value: function fetchAuthorization(authUrl) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
        var response;
        return _regeneratorRuntime().wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              _context5.next = 2;
              return this.fetchWithInterceptor(authUrl, this.requestOptions.options().withApiKey().build());
            case 2:
              response = _context5.sent;
              checkResponseError(response);
              // if an unhandled error (ex: a network error) occurs it will bubble up and need to be handled
              _context5.next = 6;
              return parseAuthResponse(response);
            case 6:
              return _context5.abrupt("return", _context5.sent);
            case 7:
            case "end":
              return _context5.stop();
          }
        }, _callee5, this);
      }));
    }
  }, {
    key: "authStateChanged",
    value: function authStateChanged(authState) {
      var _iterator2 = _createForOfIteratorHelper(this.authStateListeners),
        _step2;
      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var subscription = _step2.value;
          subscription(authState);
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
      this.lastAuthState = authState;
      return authState;
    }
    /**
     * Used when authentication is successful to apply the auth cookies to the
     * localhost domain.
     *
     * Only applies when used with a page at localhost.
     */
  }, {
    key: "localhostAuthCookies",
    value: function localhostAuthCookies() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee6() {
        var _this4 = this;
        var echoUrl, response, body;
        return _regeneratorRuntime().wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              if (isLocalhost(this.location)) {
                _context6.next = 2;
                break;
              }
              return _context6.abrupt("return");
            case 2:
              echoUrl = buildUrl(this.location, this.echoUrl);
              _context6.next = 5;
              return this.fetchWithInterceptor(echoUrl, this.requestOptions.options().withApiKey().build());
            case 5:
              response = _context6.sent;
              checkResponseError(response);
              _context6.next = 9;
              return response.json();
            case 9:
              body = _context6.sent;
              forEach(body, function (value, name) {
                if (!value) {
                  return;
                }
                _this4.cookies.setCookie(name, value, {
                  path: '/'
                });
              });
            case 11:
            case "end":
              return _context6.stop();
          }
        }, _callee6, this);
      }));
    } // Overridable Behavior
    // ====================
  }, {
    key: "afterAuthenticated",
    value: function afterAuthenticated(authState) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee7() {
        return _regeneratorRuntime().wrap(function _callee7$(_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              _context7.next = 2;
              return this.localhostAuthCookies();
            case 2:
              return _context7.abrupt("return", authState);
            case 3:
            case "end":
              return _context7.stop();
          }
        }, _callee7, this);
      }));
    }
  }, {
    key: "beforeAuthentication",
    value: function beforeAuthentication() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee8() {
        return _regeneratorRuntime().wrap(function _callee8$(_context8) {
          while (1) switch (_context8.prev = _context8.next) {
            case 0:
            case "end":
              return _context8.stop();
          }
        }, _callee8);
      }));
    }
  }, {
    key: "clearAuthStateListeners",
    value: function clearAuthStateListeners() {
      this.authStateListeners.splice(0, this.authStateListeners.length);
    }
  }, {
    key: "listenAuthState",
    value: function listenAuthState(listener) {
      var _this5 = this;
      this.authStateListeners.push(listener);
      // return a function that when called will remove the subscription from the list of subscriptions
      return function () {
        remove(_this5.authStateListeners, function (s) {
          return s === listener;
        });
      };
    }
    /**
     * Uses the configured loginBehavior to perform login.
     *
     * Current default login behavior is via immediate redirect. Will redirect back to the
     * current page if login is successful.
     */
  }, {
    key: "login",
    value: function login(returnUrl) {
      var _a;
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee9() {
        var loginBehavior;
        return _regeneratorRuntime().wrap(function _callee9$(_context9) {
          while (1) switch (_context9.prev = _context9.next) {
            case 0:
              loginBehavior = (_a = this.baseHooks.loginBehavior) !== null && _a !== void 0 ? _a : defaultLoginBehavior(returnUrl);
              _context9.next = 3;
              return loginBehavior(this, this.location);
            case 3:
            case "end":
              return _context9.stop();
          }
        }, _callee9, this);
      }));
    }
  }, {
    key: "refreshToken",
    value: function refreshToken() {
      throw new Error("".concat(this.type(), " tokens cannot be explicitly refreshed"));
    }
    /**
     * Performs the necessary steps to verify that the current user (based on
     * context from the browser) is authenticated as a proper user.
     *
     * The authentication workflow is to hit the ciam /me endpoint. If it returns
     * okay, the user is authenticated, and the response contains the user's id
     * and entitlements.
     */
  }, {
    key: "verifyAuthentication",
    value: function verifyAuthentication() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee10() {
        var authState;
        return _regeneratorRuntime().wrap(function _callee10$(_context10) {
          while (1) switch (_context10.prev = _context10.next) {
            case 0:
              _context10.prev = 0;
              _context10.next = 3;
              return this.fetchAuthorization(buildUrl(this.location, this.authUrl));
            case 3:
              authState = _context10.sent;
              _context10.next = 6;
              return this.beforeAuthentication();
            case 6:
              if (!authState.authenticated) {
                _context10.next = 12;
                break;
              }
              _context10.next = 9;
              return this.afterAuthenticated(authState);
            case 9:
              authState = _context10.sent;
              _context10.next = 15;
              break;
            case 12:
              if (!this.requireAuthentication) {
                _context10.next = 15;
                break;
              }
              _context10.next = 15;
              return this.login();
            case 15:
              _context10.next = 20;
              break;
            case 17:
              _context10.prev = 17;
              _context10.t0 = _context10["catch"](0);
              authState = NewAuthState.Error(_context10.t0);
            case 20:
              return _context10.abrupt("return", this.authStateChanged(authState));
            case 21:
            case "end":
              return _context10.stop();
          }
        }, _callee10, this, [[0, 17]]);
      }));
    }
  }]);
  return BaseAuthService;
}(); // these values are defaulted here, but their defaults may be overridden by
// the auth service construction process...to essentially a different default
// to the outside user, especially for common values like customerWebView and
// requireAuthentication
var DEFAULT_OPTIONS$2 = {
  authUrl: {
    path: 'v0/ciam-public/me',
    scheme: 'https'
  },
  loginUrl: {
    path: '/usis/login',
    scheme: 'https'
  },
  logoutUrl: {
    path: '/usis/login/logout',
    scheme: 'https'
  },
  names: {
    paramLoginReturnUrl: 'pdurl',
    paramLogoutGotoUrl: 'sdurl'
  }
};
// given an environment, returns the options specific to that environment
function defaultOptionsForEnv$1(location, env, baseDomain) {
  var cloudApiDomain = External.cloudApiDomain(env, baseDomain);
  var cloudWebDomain = External.cloudWebDomain(env, baseDomain);
  var options = {
    authUrl: {
      host: cloudApiDomain // ex: api.dev.troweprice.com
    },

    hooks: {
      loginReturnUrlBuilder: function loginReturnUrlBuilder() {
        return location.href;
      }
    },
    loginUrl: {
      host: cloudWebDomain // ex: wwwdev.troweprice.com
    },

    logoutUrl: {
      host: cloudWebDomain // ex: wwwdev.troweprice.com
    }
  };

  if (env === DEV) {
    options.echoUrl = {
      host: cloudApiDomain
    };
  }
  return options;
}
function withDefaults$1(options) {
  var collapsedOptions = merge({}, DEFAULT_OPTIONS$2, defaultOptionsForEnv$1(options.location, options.environment, options.baseDomain), options);
  // for whatever reason, in IE11 the location is changed in a way that makes it no longer
  // work by the above merge(), since the location isn't being defaulted, this reassigns
  // it so it will work again
  collapsedOptions.location = options.location;
  return collapsedOptions;
}
/**
 * An auth service that handles external users (TRP customers). See
 * verifyAuthentication() for a brief description of the external auth workflow.
 *
 * While this can be used directly, it is likely that the newAuthService()
 * constructor is desirable as it supports common and automatic confiugration.
 */
var ExternalAuthService = /*#__PURE__*/function (_BaseAuthService) {
  _inherits(ExternalAuthService, _BaseAuthService);
  function ExternalAuthService(options) {
    var _this6;
    _classCallCheck(this, ExternalAuthService);
    options = withDefaults$1(options);
    _this6 = _possibleConstructorReturn(this, _getPrototypeOf(ExternalAuthService).call(this, options));
    _this6.hooks = defaultedOpt(options.hooks);
    _this6.loginUrl = defaultedOpt(options.loginUrl);
    _this6.logoutUrl = defaultedOpt(options.logoutUrl);
    _this6.names = defaultedOpt(options.names);
    return _this6;
  }
  /**
   * The login page accepts a redirect url to go to after login is successful.
   * The current login setup embeds another redirect url into that one, however.
   * The return url from this function, then, is a url with another url in
   * a query parameter.
   *
   * @param url
   * @param returnUrl
   */
  _createClass(ExternalAuthService, [{
    key: "withReturnUrl",
    value: function withReturnUrl(url, returnUrl) {
      var _a, _b;
      if (returnUrl === undefined) {
        returnUrl = (_b = (_a = this.hooks).loginReturnUrlBuilder) === null || _b === void 0 ? void 0 : _b.call(_a);
      }
      // add return url to initial redirect url
      var loginUrl = withQueryParams(url, _defineProperty({}, this.names.paramLoginReturnUrl, buildOptionalUrl(this.location, returnUrl)));
      return buildUrl(this.location, loginUrl);
    } // AuthService
    // ===========
  }, {
    key: "buildLoginUrl",
    value: function buildLoginUrl(returnUrl) {
      var loginUrl = buildUrl(this.location, this.loginUrl);
      return this.withReturnUrl(loginUrl, returnUrl);
    }
  }, {
    key: "logout",
    value: function logout(gotoUrl) {
      var logoutUrl = this.logoutUrl;
      if (gotoUrl) {
        logoutUrl = withQueryParams(logoutUrl, _defineProperty({}, this.names.paramLogoutGotoUrl, gotoUrl));
      }
      var url = buildUrl(this.location, logoutUrl);
      // this promise intentionally does not resolve or reject, it is expected that the redirect
      // will occur and the entire app will be unloaded
      return new Promise(function () {
        window.location.assign(url);
      });
    }
  }, {
    key: "type",
    value: function type() {
      return 'external';
    }
  }]);
  return ExternalAuthService;
}(BaseAuthService); // these values are defaulted here, but their defaults may be overridden by
// the auth service construction process...to essentially a different default
// to the outside user, especially for common values like customerWebView and
// requireAuthentication
var DEFAULT_OPTIONS$1 = {
  authUrl: {
    path: '/v0/ciam-public/me',
    scheme: 'https'
  },
  loginUrl: {
    path: '/nitro_oauth-common-callback/login',
    scheme: 'https'
  },
  minInitialTtlSeconds: 5 /* minutes */ * 60,
  names: {
    paramDelegateUser: DEFAULT_DELEGATE_USER_PARAM,
    paramLoginReturnUrl: 'goto',
    paramUseScopedEntitlements: 'useScopedEntitlements'
  },
  refreshUrl: {
    path: '/nitro_oauth-common-callback/refresh',
    scheme: 'https'
  }
};
function defaultDelegateUserSource(paramName) {
  return function (location) {
    return queryParamValue(location, paramName);
  };
}
// given an environment, returns the options specific to that environment
function defaultOptionsForEnv(location, env, baseDomain) {
  var cloudApiDomain = Internal.cloudApiDomain(env, baseDomain);
  var options = {
    authUrl: {
      host: cloudApiDomain
    },
    hooks: {
      loginReturnUrlBuilder: function loginReturnUrlBuilder() {
        return location.href;
      }
    },
    loginUrl: {
      host: cloudApiDomain
    },
    logoutUrls: ["https://".concat(cloudApiDomain, "/nitro_oauth-common-callback/logout")],
    refreshOnVerify: false,
    refreshUrl: {
      host: cloudApiDomain
    }
  };
  if (env === DEV) {
    options.echoUrl = {
      host: cloudApiDomain
    };
  }
  return options;
}
function withDefaults(options) {
  var _a, _b;
  var collapsedOptions = merge({}, DEFAULT_OPTIONS$1, defaultOptionsForEnv(options.location, options.environment, options.baseDomain), options);
  // this hook relies on one of the names so can't be part of the above automatic coalesce
  if (collapsedOptions.hooks && ((_a = collapsedOptions.names) === null || _a === void 0 ? void 0 : _a.paramDelegateUser) && !((_b = collapsedOptions.hooks) === null || _b === void 0 ? void 0 : _b.delegateUserSource)) {
    collapsedOptions.hooks.delegateUserSource = defaultDelegateUserSource(collapsedOptions.names.paramDelegateUser);
  }
  // for whatever reason, in IE11 the location is changed in a way that makes it no longer
  // work by the above merge(), since the location isn't being defaulted, this reassigns
  // it so it will work again
  collapsedOptions.location = options.location;
  return collapsedOptions;
}
/**
 * An auth service that handles internal users (TRP associates). See
 * verifyAuthentication() for a brief description of the internal auth workflow.
 *
 * While this can be used directly, it is likely that the newAuthService()
 * constructor is desirable as it supports common and automatic confiugration.
 */
var InternalAuthService = /*#__PURE__*/function (_BaseAuthService2) {
  _inherits(InternalAuthService, _BaseAuthService2);
  function InternalAuthService(options) {
    var _this7;
    _classCallCheck(this, InternalAuthService);
    options = withDefaults(options);
    _this7 = _possibleConstructorReturn(this, _getPrototypeOf(InternalAuthService).call(this, options));
    _this7.minInitialTtlMs = defaultedOpt(options.minInitialTtlSeconds) * 1000;
    _this7.hooks = defaultedOpt(options.hooks);
    _this7.loginUrl = defaultedOpt(options.loginUrl);
    _this7.logoutUrls = defaultedOpt(options.logoutUrls);
    _this7.names = defaultedOpt(options.names);
    _this7.refreshOnVerify = defaultedOpt(options.refreshOnVerify);
    _this7.refreshUrl = defaultedOpt(options.refreshUrl);
    // because the urls are read only, this has to be done in the constructor
    if (!isNil(options.useScopedEntitlements)) {
      if (options.environment === DEV) {
        _this7.loginUrl = withQueryParams(_this7.loginUrl, _defineProperty({}, _this7.names.paramUseScopedEntitlements, options.useScopedEntitlements.toString()));
        _this7.refreshUrl = withQueryParams(_this7.refreshUrl, _defineProperty({}, _this7.names.paramUseScopedEntitlements, options.useScopedEntitlements.toString()));
      } else {
        console.warn('The auth service useScopedEntitlements option is set in a non-dev environment. Ignoring.');
      }
    }
    return _this7;
  }
  _createClass(InternalAuthService, [{
    key: "fetchRefresh",
    value: function fetchRefresh() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee11() {
        var refreshUrl, response, responseBody;
        return _regeneratorRuntime().wrap(function _callee11$(_context11) {
          while (1) switch (_context11.prev = _context11.next) {
            case 0:
              refreshUrl = buildUrl(this.location, this.refreshUrl);
              _context11.next = 3;
              return this.fetchWithInterceptor(refreshUrl, this.requestOptions.options().build());
            case 3:
              response = _context11.sent;
              if (response.ok) {
                _context11.next = 9;
                break;
              }
              _context11.next = 7;
              return response.text();
            case 7:
              responseBody = _context11.sent;
              throw new RefreshError(responseBody);
            case 9:
              return _context11.abrupt("return", response.json());
            case 10:
            case "end":
              return _context11.stop();
          }
        }, _callee11, this);
      }));
    }
    /**
     * For the internal auth service, the customerWebView is handled by
     * redirecting to login with the addition of a delegateUser query param.
     */
  }, {
    key: "handleDelegateUser",
    value: function handleDelegateUser() {
      var _a, _b, _c;
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee12() {
        var _this8 = this;
        var delegateUser, handleDelegateUser;
        return _regeneratorRuntime().wrap(function _callee12$(_context12) {
          while (1) switch (_context12.prev = _context12.next) {
            case 0:
              if (this.customerWebViewEnabled) {
                _context12.next = 2;
                break;
              }
              return _context12.abrupt("return", undefined);
            case 2:
              delegateUser = (_b = (_a = this.hooks) === null || _a === void 0 ? void 0 : _a.delegateUserSource) === null || _b === void 0 ? void 0 : _b.call(_a, this.location);
              if (delegateUser) {
                _context12.next = 5;
                break;
              }
              return _context12.abrupt("return", undefined);
            case 5:
              handleDelegateUser = function handleDelegateUser() {
                return _this8.login();
              };
              if (!((_c = this.hooks) === null || _c === void 0 ? void 0 : _c.delegateUserInterceptor)) {
                _context12.next = 8;
                break;
              }
              return _context12.abrupt("return", this.hooks.delegateUserInterceptor(delegateUser, handleDelegateUser));
            case 8:
              return _context12.abrupt("return", handleDelegateUser());
            case 9:
            case "end":
              return _context12.stop();
          }
        }, _callee12, this);
      }));
    }
  }, {
    key: "handleRefreshOnVerify",
    value: function handleRefreshOnVerify(authState) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee13() {
        return _regeneratorRuntime().wrap(function _callee13$(_context13) {
          while (1) switch (_context13.prev = _context13.next) {
            case 0:
              if (!(!this.refreshOnVerify && !this.underMinInitialTtlMs(authState))) {
                _context13.next = 2;
                break;
              }
              return _context13.abrupt("return", authState);
            case 2:
              _context13.prev = 2;
              _context13.next = 5;
              return this.refreshAuthState(authState);
            case 5:
              return _context13.abrupt("return", _context13.sent);
            case 8:
              _context13.prev = 8;
              _context13.t0 = _context13["catch"](2);
              console.error('Could not automatically refresh token due to short ttl.', _context13.t0);
              // this returns the original authState, since even if the refresh failed the user is
              // authenticated for some period of time still
              return _context13.abrupt("return", authState);
            case 12:
            case "end":
              return _context13.stop();
          }
        }, _callee13, this, [[2, 8]]);
      }));
    }
  }, {
    key: "loginQueryParams",
    value: function loginQueryParams(returnUrl) {
      var _a, _b, _c, _d;
      var query = {};
      var delegateUser = (_b = (_a = this.hooks).delegateUserSource) === null || _b === void 0 ? void 0 : _b.call(_a, this.location);
      if (delegateUser) {
        query[this.names.paramDelegateUser] = delegateUser;
      }
      if (returnUrl === undefined) {
        returnUrl = (_d = (_c = this.hooks).loginReturnUrlBuilder) === null || _d === void 0 ? void 0 : _d.call(_c);
      }
      if (returnUrl) {
        // internal login does not support passing query parameters in the return url
        returnUrl = withoutQuery(returnUrl);
        query[this.names.paramLoginReturnUrl] = buildUrl(this.location, returnUrl);
      }
      return query;
    }
  }, {
    key: "logoutWithUrl",
    value: function logoutWithUrl(url) {
      return new Promise(function (resolve) {
        var iframe = document.createElement('iframe');
        iframe.setAttribute('style', 'display:none;');
        iframe.onload = resolve;
        iframe.setAttribute('sandbox', '');
        iframe.src = url;
        if (document.body) {
          document.body.appendChild(iframe);
        }
        return iframe;
      });
    }
  }, {
    key: "underMinInitialTtlMs",
    value: function underMinInitialTtlMs(authState) {
      if (!authState.authenticated) {
        return false;
      }
      if (!authState.expiresAt) {
        // without an expiresAt value, no adjustments can be made
        return false;
      }
      var ttlMs = authState.expiresAt - Date.now();
      // the token will not live long enough in its current state
      return ttlMs <= this.minInitialTtlMs;
    }
  }, {
    key: "afterAuthenticated",
    value: function afterAuthenticated(authState) {
      var _this9 = this;
      var _super = Object.create(null, {
        afterAuthenticated: {
          get: function get() {
            return _get(_getPrototypeOf(InternalAuthService.prototype), "afterAuthenticated", _this9);
          }
        }
      });
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee14() {
        return _regeneratorRuntime().wrap(function _callee14$(_context14) {
          while (1) switch (_context14.prev = _context14.next) {
            case 0:
              _context14.next = 2;
              return _super.afterAuthenticated.call(this, authState);
            case 2:
              authState = _context14.sent;
              return _context14.abrupt("return", this.handleRefreshOnVerify(authState));
            case 4:
            case "end":
              return _context14.stop();
          }
        }, _callee14, this);
      }));
    }
  }, {
    key: "beforeAuthentication",
    value: function beforeAuthentication() {
      var _this10 = this;
      var _super = Object.create(null, {
        beforeAuthentication: {
          get: function get() {
            return _get(_getPrototypeOf(InternalAuthService.prototype), "beforeAuthentication", _this10);
          }
        }
      });
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee15() {
        return _regeneratorRuntime().wrap(function _callee15$(_context15) {
          while (1) switch (_context15.prev = _context15.next) {
            case 0:
              _context15.next = 2;
              return this.handleDelegateUser();
            case 2:
              _context15.next = 4;
              return _super.beforeAuthentication.call(this);
            case 4:
            case "end":
              return _context15.stop();
          }
        }, _callee15, this);
      }));
    }
    /**
     * Handles the low-level operation of refreshing the auth state's token. This encompasses making
     * the HTTP hit, but doesn't do any state management or event firing.
     *
     * @param authState
     */
  }, {
    key: "refreshAuthState",
    value: function refreshAuthState(authState) {
      var _a;
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee16() {
        var response;
        return _regeneratorRuntime().wrap(function _callee16$(_context16) {
          while (1) switch (_context16.prev = _context16.next) {
            case 0:
              if (authState) {
                _context16.next = 2;
                break;
              }
              throw new Error('Cannot refresh, missing auth state. Use verifyAuthentication().');
            case 2:
              if (authState.authenticated) {
                _context16.next = 4;
                break;
              }
              throw new Error('Cannot refresh unauthenticated token. Use login().');
            case 4:
              _context16.next = 6;
              return this.fetchRefresh();
            case 6:
              response = _context16.sent;
              if (response.expiresAtMs) {
                _context16.next = 9;
                break;
              }
              throw new Error('Refresh token response is missing expiration.');
            case 9:
              return _context16.abrupt("return", Object.assign(Object.assign({}, authState), {
                expiresAt: response.expiresAtMs,
                refresh: Object.assign(Object.assign({}, authState.refresh), {
                  expiresAt: (_a = response.refresh) === null || _a === void 0 ? void 0 : _a.expiresAtMs
                })
              }));
            case 10:
            case "end":
              return _context16.stop();
          }
        }, _callee16, this);
      }));
    } // AuthService
    // ===========
  }, {
    key: "buildLoginUrl",
    value: function buildLoginUrl(returnUrl) {
      var loginUrl = withQueryParams(this.loginUrl, this.loginQueryParams(returnUrl));
      return buildUrl(this.location, loginUrl);
    }
  }, {
    key: "logout",
    value: function logout(gotoUrl) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee17() {
        var _this11 = this;
        return _regeneratorRuntime().wrap(function _callee17$(_context17) {
          while (1) switch (_context17.prev = _context17.next) {
            case 0:
              if (!isEmpty(this.logoutUrls)) {
                _context17.next = 3;
                break;
              }
              console.warn('No logoutUrls configured.');
              return _context17.abrupt("return");
            case 3:
              _context17.next = 5;
              return Promise.all(this.logoutUrls.map(function (url) {
                return _this11.logoutWithUrl(url);
              }));
            case 5:
              if (gotoUrl) {
                window.location.assign(gotoUrl);
              }
            case 6:
            case "end":
              return _context17.stop();
          }
        }, _callee17, this);
      }));
    }
    /**
     * Refreshes the oauth token for the current auth service. This token is unavailable to the
     * browser. It is refreshed via a server hit that is passing the refresh token via a cookie. To
     * use this endpoint, verify a refresh is possible (the session is internal, authenticated, etc.)
     * but assume the refresh could still fail.
     *
     * Returns the updated authState (with an updated expiresAt value) if the refresh succeeded. If
     * the refresh doesn't succeed, an error is thrown.
     */
  }, {
    key: "refreshToken",
    value: function refreshToken() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee18() {
        var refreshedAuthState;
        return _regeneratorRuntime().wrap(function _callee18$(_context18) {
          while (1) switch (_context18.prev = _context18.next) {
            case 0:
              _context18.next = 2;
              return this.refreshAuthState(this.lastAuthState);
            case 2:
              refreshedAuthState = _context18.sent;
              return _context18.abrupt("return", this.authStateChanged(refreshedAuthState));
            case 4:
            case "end":
              return _context18.stop();
          }
        }, _callee18, this);
      }));
    }
  }, {
    key: "type",
    value: function type() {
      return 'internal';
    }
  }]);
  return InternalAuthService;
}(BaseAuthService);
function checkCustomerWebView(options) {
  if (options.customerWebViewEnabled && !options.types.external && !options.types.internal) {
    throw new Error('WHen customerWebViewEnabled, must include both external and internal auth types.');
  }
}
// applies common options from passed configuration
function baseAuthOptions(options, authType) {
  var _a, _b, _c, _d;
  var environment = (_a = options.envProvider) === null || _a === void 0 ? void 0 : _a.call(options,
  // in practice the location will be there, but type enforcement complains
  (_c = (_b = options.location) === null || _b === void 0 ? void 0 : _b.hostname) !== null && _c !== void 0 ? _c : '', authType.typeMapping);
  if (!environment) {
    throw new Error('Missing environment.');
  }
  checkCustomerWebView(options);
  return Object.assign({
    apiKey: options.apiKey,
    authType: authType,
    baseDomain: authType.typeMapping.domain,
    cookies: (_d = options.cookies) !== null && _d !== void 0 ? _d : new DocumentCookies(),
    customerWebViewEnabled: options.customerWebViewEnabled,
    environment: environment,
    fetch: options.fetch,
    location: checkedLocation(options.location),
    requireAuthentication: options.requireAuthentication
  }, options.types[authType.typeMapping.type]);
}
// coerces base options into external options
function externalOptions(options, authType) {
  return Object.assign(Object.assign({}, baseAuthOptions(options, authType)), options.types.external);
}
// coerces base options into internal options
function internalOptions(options, authType) {
  return Object.assign(Object.assign({}, baseAuthOptions(options, authType)), options.types.internal);
}
var DEFAULT_OPTIONS = {
  authTypeMappings: [{
    domain: EXTERNAL_DOMAIN,
    hostRegex: regexSubdomainsOf(EXTERNAL_DOMAIN),
    type: 'external'
  }, {
    domain: INTERNAL_DOMAIN,
    hostRegex: regexSubdomainsOf(INTERNAL_DOMAIN),
    type: 'internal'
  }],
  customerWebViewEnabled: false,
  envProvider: environmentFromDomain,
  location: windowLocation(),
  redirectOnMismatchedAuthType: true,
  requireAuthentication: true,
  storage: localStorage()
};
/**
 * This is the primary entry point for using the auth service. It uses the
 * options it is passed, combined with internal defaults, to determine the
 * type of auth that needs to occur (internal or external) from the context
 * of the current page. It then instantiates the proper auth service and
 * returns it.
 *
 * @param options See type definition for description.
 */
function newAuthService(options) {
  var _a;
  options = assign({}, DEFAULT_OPTIONS, options);
  var typeMappings = options.authTypeMappings;
  if (!typeMappings) {
    throw new Error('Missing typeMappings');
  }
  var authType = new AuthType({
    location: checkedLocation(options.location),
    redirectInterceptor: (_a = options.hooks) === null || _a === void 0 ? void 0 : _a.authTypeRedirectInterceptor,
    redirectOnUnsupportedType: options.redirectOnMismatchedAuthType,
    storage: options.storage,
    supportedTypes: keys(options.types),
    typeMappings: typeMappings
  });
  switch (authType.typeMapping.type) {
    case TYPE_EXTERNAL:
      return new ExternalAuthService(externalOptions(options, authType));
    case TYPE_INTERNAL:
      return new InternalAuthService(internalOptions(options, authType));
    default:
      throw new UnknownAuthTypeError(authType.typeMapping.type, TYPES);
  }
}
export { CommonLogoutCallback, environmentFromDomain, newAuthService };